import {Component} from 'react';
import PropTypes from 'prop-types';

/*
	This component should be rendered by any component which has "focus" and
	want to respond to being "selected".
*/

export default class KeyboardSelectionListener extends Component {
  componentDidMount() {
      this.listener = (event) => {
      	if (event.key === 'Enter' || event.key === ' ') {
      		if (event.ctrlKey || event.metaKey || event.shiftKey) {
      			return;
      		}

      		this.props.on_select(event);
      	}
      }
      window.addEventListener('keypress', this.listener);
  }
  componentWillUnmount() {
  	window.removeEventListener('keypress', this.listener);
  }
	render() {
		return null;
	}
}
KeyboardSelectionListener.propTypes = {
	// A "selection" event handler. 
	// Will be passed the KeyboardEvent which triggered this "selection".
	on_select: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/KeyboardSelectionListener.js